  function scalePolygon(polygon, scaleFactor) {
    let centroid = calculateCentroid(polygon);

    // Scale each coordinate around the centroid
    return polygon.map(function(poly) {
      return poly.map((ring) => {
        return ring.map((coord) => {
          let dx = coord[0] - centroid[0];
          let dy = coord[1] - centroid[1];
          return [(centroid[0] + dx * scaleFactor) , (centroid[1] + dy * scaleFactor) ];
        })
      })
    });
  }

  function  shiftPolygon(polygon, xShift, yShift) {
   let centroid = calculateCentroid(polygon);

    return polygon.map((poly) => {
      return poly.map((ring) => {
        return ring.map((coord) => {
          let dx = coord[0] - centroid[0] + xShift;
          let dy = coord[1] - centroid[1] + yShift;

          return [centroid[0] + dx, coord[1] + dy]

        })
      })
    })
  }


  function calculateCentroid(polygon) {
    let totalX = 0;
    let totalY = 0;
    let totalPoints = 0;
    polygon.forEach(function(poly) {
        poly.forEach(function(ring) {
            ring.forEach(function(point) {
                totalX += point[0];
                totalY += point[1];
                totalPoints++;
            });
        });
    });

    let centroidX = totalX / totalPoints;
    let centroidY = totalY / totalPoints;

    return [centroidX, centroidY];
}

export {scalePolygon, calculateCentroid, shiftPolygon }
